import store from "@/store";
import { Message } from "element-ui";

// 根据当前语言弹出对应错误提示
export function alertError(data) {
  const prompt = store.getters["language/getLanguage"] == "zh" ? data.subMsg || "请求失败" : data.msg || "Request failed";
  Message.error(prompt);
}
